import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-side-panel',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './sidepanel-reusable.html',
  styleUrl: './sidepanel-reusable.css'
})
export class SidepanelReusable {
  @Input() isOpen = false;
  @Input() width = 'w-96';
  @Input() peekWidthPx = 24;
  @Output() closed = new EventEmitter<void>();
  @Output() isOpenChange = new EventEmitter<boolean>();

  get panelTransform(): string {
    return this.isOpen ? 'translateX(0)' : `translateX(calc(100% - ${this.peekWidthPx}px))`;
  }

  open(): void {
    this.isOpenChange.emit(true);
  }

  close(): void {
    this.isOpenChange.emit(false);
    this.closed.emit();
  }
}
